module.exports = __webpack_public_path__ + "static/media/6-noactive.a8b750a6.svg";